module.exports = __webpack_public_path__ + "static/media/pdf-new.cb33ba9f.svg";